<div
  id="uzd-molochnuh-zaloz"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12 clr-col-md-6">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="mol_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">День менструального циклу:</label>
          <input [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput formControlName="mol_menstrual_day" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-6">
        <div class="text-center-container bold-text text-center">
          <strong>Права молочна залоза</strong>
        </div>

        <div class="clr-row button-row">
          <div class="clr-col-sm-12 button-left">
            <button class="btn btn-primary" (click)="copyDataToTextArea(' залозиста таканина ', 'mol_right_perevazae')">  залозиста таканина;  </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' жирова тканина ', 'mol_right_perevazae')"> жирова тканина; </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' приблизно рівне співвідношення залозистої та жирової тканини ', 'mol_right_perevazae')"> приблизно рівне співвідношення залозистої та жирової тканини; </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' міждолевий фіброз: виражений ', 'mol_right_perevazae')"> міждолевий фіброз: виражений </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' міждолевий фіброз: невиражений ', 'mol_right_perevazae')"> міждолевий фіброз: невиражений </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' міждолевий фіброз: відсутній ', 'mol_right_perevazae')"> міждолевий фіброз: відсутній </button>
          </div>
          <div class="clr-col-sm-12 full-width-input">
            <clr-textarea-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Переважає</label>
              <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_right_perevazae"></textarea>
            </clr-textarea-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Верхній зовнішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pvzk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pvzk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pvzk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Верхній внутрішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pvvk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pvvk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pvvk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Нижній зовнішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pnzk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pnzk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pnzk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Нижній внутрішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pnvk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pnvk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_pnvk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ділянка соска</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_plds" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row button-row">
          <div class="clr-col-sm-12 button-left">
            <button class="btn btn-primary" (click)="copyDataToTextArea('поширені до  мм.', 'mol_plmh')">  поширені до  мм.  </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea('не поширені', 'mol_plmh')"> не поширені </button>
          </div>
          <div class="clr-col-sm-12 full-width-input">
            <clr-textarea-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Молочні ходи</label>
              <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_plmh"></textarea>
            </clr-textarea-container>
          </div>
        </div>

        <div class="clr-row button-row">
          <div class="clr-col-sm-12 button-left">
            <button class="btn btn-primary" (click)="copyDataToTextArea('візуалізуються до  мм.', 'mol_prlv')">  візуалізуються до  мм.  </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea('не візуалізуються', 'mol_prlv')"> не візуалізуються </button>
          </div>
          <div class="clr-col-sm-12 full-width-input">
            <clr-textarea-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Регіональні лімфовузли</label>
              <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_prlv"></textarea>
            </clr-textarea-container>
          </div>
        </div>


      </div>

      <div class="clr-col-sm-6 ">
        <div class="text-center-container text-center bold-text">
          <strong>Ліва молочна залоза</strong>
        </div>

        <div class="clr-row button-row">
          <div class="clr-col-sm-12 button-left">
            <button class="btn btn-primary" (click)="copyDataToTextArea(' залозиста таканина ', 'mol_left_perevazae')">  залозиста таканина;  </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' жирова тканина ', 'mol_left_perevazae')"> жирова тканина; </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' приблизно рівне співвідношення залозистої та жирової тканини ', 'mol_left_perevazae')"> приблизно рівне співвідношення залозистої та жирової тканини; </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' міждолевий фіброз: виражений ', 'mol_left_perevazae')"> міждолевий фіброз: виражений </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' міждолевий фіброз: невиражений ', 'mol_left_perevazae')"> міждолевий фіброз: невиражений </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea(' міждолевий фіброз: відсутній ', 'mol_left_perevazae')"> міждолевий фіброз: відсутній </button>
          </div>
          <div class="clr-col-sm-12 full-width-input">
            <clr-textarea-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Переважає</label>
              <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_left_perevazae"></textarea>
            </clr-textarea-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Верхній зовнішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lvzk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lvzk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lvzk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Верхній внутрішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lvvk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lvvk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lvvk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Нижній зовнішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lnzk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lnzk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lnzk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="text-left-container bold-text">
          <strong>Нижній внутрішній квадрант:</strong>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">а) анехогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lnvk_aneho" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">б) гіпоехогенні.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lnvk_gipo" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">в) гетерогенні вкл.</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_lnvk_getero" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row">
          <div class="clr-col-sm-12 full-width-input">
            <clr-input-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ділянка соска</label>
              <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="mol_llds" />
            </clr-input-container>
          </div>
        </div>

        <div class="clr-row button-row">
          <div class="clr-col-sm-12 button-left">
            <button class="btn btn-primary" (click)="copyDataToTextArea('поширені до  мм.', 'mol_llmh')">  поширені до  мм.  </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea('не поширені', 'mol_llmh')"> не поширені </button>
          </div>
          <div class="clr-col-sm-12 full-width-input">
            <clr-textarea-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Молочні ходи</label>
              <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_llmh"></textarea>
            </clr-textarea-container>
          </div>
        </div>

        <div class="clr-row button-row">
          <div class="clr-col-sm-12 button-left">
            <button class="btn btn-primary" (click)="copyDataToTextArea('візуалізуються до  мм.', 'mol_lrlv')">  візуалізуються до  мм.  </button>
            <button class="btn btn-primary" (click)="copyDataToTextArea('не візуалізуються', 'mol_lrlv')"> не візуалізуються </button>
          </div>
          <div class="clr-col-sm-12 full-width-input">
            <clr-textarea-container>
              <label [ngStyle]="{ 'font-size.px': options.fontSize }">Регіональні лімфовузли</label>
              <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_lrlv"></textarea>
            </clr-textarea-container>
          </div>
        </div>
      </div>

      <div class="clr-row button-row">
        <div class="clr-col-sm-12 button-left">
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Фіброзно кистозна мастопатія ', 'mol_zakluchennya')">  Фіброзно кистозна мастопатія  </button>
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Фіброаденома ', 'mol_zakluchennya')">  Фіброаденома  </button>
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Об\'ємних утворів на момент огляду не виявлено ', 'mol_zakluchennya')">  Об'ємних утворів на момент огляду не виявлено   </button>
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Дифузна фіброзна мастопатія ', 'mol_zakluchennya')"> Дифузна фіброзна мастопатія </button>
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Лактостаз ', 'mol_zakluchennya')"> Лактостаз </button>
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Жирова інволюція молочних залоз ', 'mol_zakluchennya')"> Жирова інфолюція молочних залоз </button>
          <button class="btn btn-primary" (click)="copyDataToTextArea(' Жирова інволюція молочних залоз ', 'mol_zakluchennya')"> Жирова інфолюція молочних залоз </button>
        </div>
        <div class="clr-col-sm-12 full-width-input">
          <clr-textarea-container>
            <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЗАКЛЮЧЕННЯ:</label>
            <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_zakluchennya"></textarea>
          </clr-textarea-container>
        </div>
      </div>

      <div class="clr-row button-row">
        <div class="clr-col-sm-12 button-left">
          <button class="btn btn-primary" (click)="copyDataToTextArea('Консультація мамолога', 'mol_recomendovano')"> Консультація мамолога </button>
        </div>
        <div class="clr-col-sm-12 full-width-input">
          <clr-textarea-container>
            <label [ngStyle]="{ 'font-size.px': options.fontSize }">РЕКОМЕНДОВАНО:</label>
            <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="mol_recomendovano"></textarea>
          </clr-textarea-container>
        </div>
      </div>

    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>
  </form>

</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
